// Analytics.js – Chakra-UI analytics dashboard (B2C & B2B) – version 2025-07-02
import React from "react";
import {
  Box,
  Flex,
  Heading,
  Text,
  Input,
  InputGroup,
  InputLeftElement,
  IconButton,
  HStack,
  Avatar,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
import { Bell, Wallet, Search, HelpCircle, Users, Building2 } from "lucide-react";

/* ---------- WIDGET IMPORTS ---------- */
/*import {
  KpiSummaryCards,
  EngagementFunnel,
  CampaignPerformance,
  SegmentInsights,
  AutomationStatus,
  AttributionInsights,
  DataQualityHealth,
  ProductPerformance,
  UserActivitySync,
  AlertsRecommendations,
  B2BKpiSummaryCards,
  B2BAccountEngagementFunnel,
} from "./analytics-components";*/

import { KpiSummaryCards } from './analytics-components/KpiSummaryCards';

import { EngagementFunnel } from './analytics-components/EngagementFunnel';
import { CampaignPerformance } from './analytics-components/CampaignPerformance';
import { SegmentInsights } from './analytics-components/SegmentInsights';
import { AutomationStatus } from './analytics-components/AutomationStatus';
import { AttributionInsights } from './analytics-components/AttributionInsights';

import { DataQualityHealth } from './analytics-components/DataQualityHealth';
import { ProductPerformance } from './analytics-components/ProductPerformance';
import { UserActivitySync } from './analytics-components/UserActivitySync';
import { AlertsRecommendations } from './analytics-components/AlertsRecommendations';
import { B2BKpiSummaryCards } from './analytics-components/B2BKpiSummaryCards';
import { B2BAccountEngagementFunnel } from './analytics-components/B2BAccountEngagementFunnel';
/* ---------- MAIN PAGE ---------- */
export default function DemoAnalytics() {
  const pageBg = useColorModeValue("gray.50", "gray.900");

  return (
    <Box bg={pageBg} minH="100vh">
      <Box px={{ base: 4, md: 8 }} py={6} maxW="7xl" mx="auto">
        {/* Page title */}
        <Box mb={8}>
          <Heading size="lg" mb={2}>
            Analytics Dashboard
          </Heading>
          <Text color="gray.600">
            Comprehensive insights into your customer engagement and business performance
          </Text>
        </Box>

        {/* Tabs for B2C / B2B */}
        <Tabs variant="enclosed" colorScheme="purple">
          <TabList>
            <Tab>
              <Users size={16} style={{ marginRight: 6 }} /> B2C Dashboard
            </Tab>
            <Tab>
              <Building2 size={16} style={{ marginRight: 6 }} /> B2B Dashboard
            </Tab>
          </TabList>

          <TabPanels mt={6}>
            {/* ---------------- B2C TAB ---------------- */}
            <TabPanel>
              <Box mb={6}>
                <KpiSummaryCards />
              </Box>

              <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6} mb={6}>
                <EngagementFunnel />
                <CampaignPerformance />
              </SimpleGrid>

              <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6} mb={6}>
                <SegmentInsights />
                <AutomationStatus />
              </SimpleGrid>

              <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6} mb={6}>
                <AttributionInsights />
                <DataQualityHealth />
              </SimpleGrid>

              <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6} mb={6}>
                <UserActivitySync />
                <ProductPerformance />
              </SimpleGrid>

              <AlertsRecommendations />
            </TabPanel>

            {/* ---------------- B2B TAB ---------------- */}
            <TabPanel>
              <Box mb={6}>
                <B2BKpiSummaryCards />
              </Box>

              <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6} mb={6}>
                <B2BAccountEngagementFunnel />
                <CampaignPerformance />
              </SimpleGrid>

              <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6} mb={6}>
                <SegmentInsights />
                <AutomationStatus />
              </SimpleGrid>

              <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6} mb={6}>
                <AttributionInsights />
                <DataQualityHealth />
              </SimpleGrid>

              <SimpleGrid columns={{ base: 1, lg: 2 }} gap={6} mb={6}>
                <UserActivitySync />
                <ProductPerformance />
              </SimpleGrid>

              <AlertsRecommendations />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
}
